import React from 'react';
import { FaMedium, FaYoutube, FaGithub, FaCopyright, FaComments } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { Link } from 'react-router-dom';

const xUrl = 'https://x.com/BubbleAnalytics';
const talkMarketsUrl = 'https://talkmarkets.com/profile/ben-lockhart-261004-174911';

const Footer = () => {
  return (
    <div className="max-w-[1090px] mx-auto py-2 px-6 mb-10 grid lg:grid-cols-3 gap-8 text-gray-300 md:px-8">
      {/* First column */}
      <div className="text-center lg:text-left">
        <h1 className="w-full text-[17px] font-hyperlegible font-normal text-gray-500 flex items-center justify-center lg:justify-start">
          <FaCopyright size={15} className="mr-1" /> Bubble Analytics 2026
        </h1>
        <h1 className="text-[15px] font-normal py-2">
          Market <span className="text-[#00df9a]">Focused</span> Data <span className="text-[#00df9a]">Analytics</span>
        </h1>
        <p className="text-[15px] font-hyperlegible font-thin py-1">
          <a href="mailto:info@bubble-analytics.com" className="text-gray-300 hover:text-[#00df9a]">
            info@bubble-analytics.com
          </a>
        </p>
        <div className="w-full flex items-center justify-center lg:justify-start my-2 space-x-4">
          <a
            href="https://medium.com/@bubble_analytics"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#00df9a]"
          >
            <FaMedium size={20} />
          </a>
          <a
            href={talkMarketsUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Ben Lockhart on TalkMarkets"
            title="TalkMarkets"
            className="hover:text-[#00df9a]"
          >
            <FaComments size={20} aria-hidden="true" />
          </a>
          <a
            href={xUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#00df9a]"
          >
            <FaXTwitter size={20} />
          </a>
          <a
            href="https://www.youtube.com/@bubble-analytics"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#00df9a]"
          >
            <FaYoutube size={20} />
          </a>
          <a
            href="https://github.com/Bubble-Analytics"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#00df9a]"
          >
            <FaGithub size={20} />
          </a>
        </div>
      </div>

      {/* Second & subsequent columns */}
      <div className="lg:col-span-2 flex justify-between mt-0 lg:ml-8">
        <div className="text-left">
          <h6 className="font-hyperlegible text-base font-thin text-gray-500">Services</h6>
          <ul>
            <li className="py-1 text-[15px]">
              <Link to="/backtesting" className="text-gray-300 hover:text-[#00df9a]">Backtesting</Link>
            </li>
            <li className="py-1 text-[15px]">
              <Link to="/automation" className="text-gray-300 hover:text-[#00df9a]">Automation</Link>
            </li>
            <li className="py-1 text-[15px]">
              <Link to="/signals" className="text-gray-300 hover:text-[#00df9a]">Trade Alerts</Link>
            </li>
            <li className="py-1 text-[15px]">
              <Link to="/macro" className="text-gray-300 hover:text-[#00df9a]">Macro</Link>
            </li>
            <li className="py-1 text-[15px]">
              <Link to="/contact" className="text-gray-300 hover:text-[#00df9a]">Consultation</Link>
            </li>
          </ul>
        </div>
        <div className="text-left">
          <h6 className="font-hyperlegible text-base font-thin text-gray-500">Support</h6>
          <ul>
            <li className="py-1 text-[15px]">
              <Link to="/faq" className="text-gray-300 hover:text-[#00df9a]">FAQ</Link>
            </li>
            <li className="py-1 text-[15px]">
              <a
                href="https://github.com/Bubble-Analytics"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-[#00df9a]"
              >
                Github
              </a>
            </li>
            <li className="py-1 text-[15px]">
              <Link to="/blog" className="text-gray-300 hover:text-[#00df9a]">Blog</Link>
            </li>
            <li className="py-1 text-[15px]">
              <Link to="/contact" className="text-gray-300 hover:text-[#00df9a]">Contact</Link>
            </li>
          </ul>
        </div>
        <div className="text-left">
          <h6 className="font-hyperlegible text-base font-thin text-gray-500">Media</h6>
          <ul>
            <li className="py-1 text-[15px]">
              <a
                href="https://www.youtube.com/@bubble-analytics"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-[#00df9a]"
              >
                Youtube
              </a>
            </li>
            <li className="py-1 text-[15px]">
              <a
                href="https://medium.com/@bubble_analytics"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-[#00df9a]"
              >
                Medium
              </a>
            </li>
            <li className="py-1 text-[15px]">
              <a
                href={talkMarketsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-[#00df9a]"
              >
                TalkMarkets
              </a>
            </li>
            <li className="py-1 text-[15px]">
              <a
                href={xUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-[#00df9a]"
              >
                X
              </a>
            </li>
          </ul>
        </div>
        <div className="text-left">
          <h6 className="font-hyperlegible text-base font-thin text-gray-500">Legal</h6>
          <ul>
            <li className="py-1 text-[15px]">
              <Link to="/Company" className="text-gray-300 hover:text-[#00df9a]">Company</Link>
            </li>
            <li className="py-1 text-[15px]">
              <Link to="/Terms" className="text-gray-300 hover:text-[#00df9a]">Terms of Service</Link>
            </li>
            <li className="py-1 text-[15px]">
              <Link to="/Privacy" className="text-gray-300 hover:text-[#00df9a]">Privacy Policy</Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Footer;
